export default [
  {
    path: '/quotes',
    name: 'quotes',
    component: () =>
      import(/* webpackChunkName: "Quotes" */
        /* webpackMode: "lazy" */
        `./views/QuoteList.vue`)
  }
]
